export default __webpack_public_path__ + "static/media/46.0228d725.jpeg";